import { createReducer } from '@reduxjs/toolkit'
import { resetFiltrePlantilles, setFiltrePlantilles } from '../actions/FiltrePlantillesAction'
import { Filtre } from 'models'

export type FiltrePlantillesType = Pick<
  Filtre,
  | 'nomPlantilla'
  | 'nomOrgan'
  | 'suport'
  | 'origenDocument'
  | 'estatElaboracio'
  | 'signaturaOrigen'
  | 'csvRequerit'
>

const initialFiltrePlantilles: FiltrePlantillesType = {
  nomPlantilla: '',
  nomOrgan: '',
  suport: '',
  origenDocument: '',
  csvRequerit: '',
  estatElaboracio: '',
  signaturaOrigen: ''
}

const filtrePlantillesReducer = createReducer(initialFiltrePlantilles, (builder) => {
  builder
    .addCase(resetFiltrePlantilles, () => {
      return initialFiltrePlantilles
    })
    .addCase(setFiltrePlantilles, (_state, action) => {
      return action.payload
    })
})

export default filtrePlantillesReducer
